// extracted by mini-css-extract-plugin
module.exports = {"carouselWrapper":"_20xiY"};